import React, { useEffect } from "react";

import { styled } from "@mui/material/styles";
import { Box, CircularProgress, Typography } from "@mui/material";

import CollapseCard from "components/Collapse";
import TwoColumnContainer from "components/Container/TwoColumnContainer";
import InputField from "components/InputField";

import { validateDeviceAccount } from 'utils/validate';

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.customFontSize[2],
  color: theme.palette.primary.black,
  fontWeight: theme.typography.customFontWeight[1],
  marginTop: "16px"
}));

const DevicePanel = ({
  loading,
  viewerPermissions,
  setDataChangesFlag,
  handleDataChanged,
  dataCancelFlag,
  setDataCancelFlag,
  originalData,
  networkInfoData,
  setNetworkInfoData,
  deviceNameError,
  setDeviceNameError
}) => {
  function hasDevicesChanged() {
    if (!originalData.info) return false;
    if (
      networkInfoData.deviceName !== originalData.info.deviceName ||
      networkInfoData.address !== originalData.info.address
    )
      return true;

    return false;
  }

  useEffect(() => {
    const changed = hasDevicesChanged();
    setDataChangesFlag((prev) => ({
      ...prev,
      device: changed,
    }));
    if (changed) {
      handleDataChanged({
        data: {
          info: networkInfoData,
        },
      });
    }
  }, [networkInfoData, originalData]);

  useEffect(() => {
    if (dataCancelFlag.device === true && originalData.info) {
      setNetworkInfoData(originalData.info);
      setDataCancelFlag((prev) => ({ ...prev, device: false }));
    }
  }, [dataCancelFlag, originalData]);

  return (
    <CollapseCard title="Device" minWidth="550px">
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TwoColumnContainer label="Device Name">
            <Box width={325}>
              {
                viewerPermissions
                  ? <StyledTypography>{networkInfoData.deviceName || "-"}</StyledTypography>
                  : <InputField
                    value={networkInfoData.deviceName}
                    isValid={!deviceNameError}
                    maxLength={32}
                    onChange={(value) => {
                      const errorResult = validateDeviceAccount(value, true);
                      setDeviceNameError(errorResult.valid ? "" : errorResult.msg);
                      setNetworkInfoData((pre) => ({ ...pre, deviceName: value }));
                    }}
                  />
              }
            </Box>
          </TwoColumnContainer>
          <TwoColumnContainer label="Address">
            <Box width={325}>
              {
                viewerPermissions
                  ? <StyledTypography>{networkInfoData.address || "-"}</StyledTypography>
                  : <InputField
                    value={networkInfoData.address}
                    onChange={(value) => {
                      setNetworkInfoData((pre) => ({ ...pre, address: value }));
                    }}
                  />
              }
            </Box>
          </TwoColumnContainer>
        </>
      )}
    </CollapseCard>
  );
};

export default DevicePanel;
